import { useEffect, useCallback } from 'react';

export const usePylon = ({ appId, currUser }) => {
  const handleOnLoad = useCallback(() => {
    (() => {
      window.pylon = {
        chat_settings: {
          app_id: appId,
          email: currUser?.email,
          name: currUser?.first_name,
        },
      };
    })();
  }, [appId, currUser]);

  useEffect(() => {
    if (!appId) return;

    const scriptId = 'pylon-widget-script';
    if (document.getElementById(scriptId)) return;

    // Initialize Pylon on window if not already present
    if (!window.Pylon) {
      const Pylon = function () {
        Pylon.e(arguments);
      };
      Pylon.q = [];
      Pylon.e = function (args) {
        Pylon.q.push(args);
      };
      window.Pylon = Pylon;
    }

    const script = document.createElement('script');
    script.id = scriptId;
    script.src = `https://widget.usepylon.com/widget/${appId}`;
    script.async = true;

    document.body.appendChild(script);
    script.onload = () => handleOnLoad();

    return () => {
      document.body.removeChild(script);
    };
  }, [appId, handleOnLoad]);
};
